webpackJsonp([1],{

/***/ "AO5d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__converter__ = __webpack_require__("F3ld");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/** @class Page */
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['testOutput'],
  data: function data() {
    return {
      failuresPlaceholder: 'PHPUnit 3.4.13 by Sebastian Bergmann.\n\nF\n\nTime: 0 seconds, Memory: 5.75Mb\n\nThere was 1 failure:\n\n1) TestSimpleMultiplier::test_multiply_simple\nMultiplying 2 and 3 did not return 6\nFailed asserting that <6> matches expected <7>.\n\n.../testMessage.php:23\n\nFAILURES!\nTests: 1, Assertions: 1, Failures: 1.\n'
    };
  },

  computed: {
    matches: function matches() {
      var matches = Object(__WEBPACK_IMPORTED_MODULE_0__converter__["b" /* getMatches */])(this.testOutput);
      var escapeBackslahes = function escapeBackslahes(input) {
        return input.replace(/\\/g, '\\\\');
      };
      var phpstormCommand = Object(__WEBPACK_IMPORTED_MODULE_0__converter__["a" /* convertMatchesToPhpStormArgument */])(matches);
      matches.sort();
      return {
        count: matches.length,
        files: matches.join("\n"),
        phpstormCommand: phpstormCommand,
        cliCommand: phpstormCommand ? 'phpunit ' + escapeBackslahes(phpstormCommand) : ''
      };
    }
  },
  components: {}
});

/***/ }),

/***/ "F3ld":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getMatches; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertMatchesToPhpStormArgument; });
/* unused harmony export test */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


/**
 * Gets a list of matched tests.
 *
 * @param sourceString
 * @return {Array}
 */
function getMatches(sourceString) {
  var pattern = /\s+\d+\) ([\w\\\\:]+( with data set [^\s]+)?)/g;
  var match = void 0;
  var matches = [];
  // eslint-disable-next-line no-cond-assign
  while ((match = pattern.exec(sourceString)) !== null) {
    matches.push(match[1]);
  }
  return matches;
}

/**
 * Returns a string joined with a pipe (|) and surrounded by parentheses for regex.
 * If there is only one string, it does not surround the string with parentheses.
 *
 * @param {String[]} stringArray
 * @return String
 */
function joinRegex(stringArray) {
  return stringArray.length > 1 ? '(' + stringArray.join('|') + ')' : stringArray[0];
}

function convertMatchesToPhpStormArgument(matches) {
  var classes = {};
  matches.forEach(function (match) {
    var _getMatchParts = getMatchParts(match),
        _class = _getMatchParts._class,
        method = _getMatchParts.method,
        dataset = _getMatchParts.dataset;

    if (!classes[_class]) {
      classes[_class] = {};
    }
    var savedClassMethods = classes[_class];
    if (!savedClassMethods[method]) {
      savedClassMethods[method] = [];
    }
    var savedMethodDatasets = savedClassMethods[method];
    savedMethodDatasets.push(dataset);
  });
  var tests = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(classes).map(function (className) {
    return className + groupMethods(classes[className]);
  });
  var escapeBackslahes = function escapeBackslahes(input) {
    return input.replace(/\\/g, '\\\\');
  };
  return matches.length ? '--filter "/' + escapeBackslahes(joinRegex(tests)) + '$/"' : '';
}

function getMatchParts(match) {
  var _match$match = match.match(/^([^:]+::)([^ ]+)( with data set .*)?$/),
      _match$match2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_match$match, 4),
      _class = _match$match2[1],
      method = _match$match2[2],
      dataset = _match$match2[3];

  return { _class: _class, method: method, dataset: dataset || '' };
}

function groupMethods(methodKeyObject) {
  var asArray = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(methodKeyObject).map(function (method) {
    return method + joinRegex(methodKeyObject[method]);
  });
  return joinRegex(asArray);
}

/** Methods not to be used, but exposed for testing purposes */
var test = { getMatchParts: getMatchParts, groupMethods: groupMethods };



/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc235ee6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Vtpa");
function injectStyle (ssrContext) {
  __webpack_require__("jHR+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc235ee6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "TFpr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vtpa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"testOutput":_vm.testOutput},on:{"update:testOutput":function($event){_vm.testOutput=$event}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Page__ = __webpack_require__("pMNZ");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Page__["a" /* default */]
  }]
}));

/***/ }),

/***/ "jHR+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pMNZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page_vue__ = __webpack_require__("AO5d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f175f1d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page_vue__ = __webpack_require__("zPFw");
function injectStyle (ssrContext) {
  __webpack_require__("TFpr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Page_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f175f1d8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Page_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      testOutput: ''
    };
  }
});

/***/ }),

/***/ "zPFw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("PhpUnit Failures")]),_vm._v(" "),_c('p',[_vm._v("\n    This web app lets you paste the output of test failures in PhpUnit, and it gives you scripts with which you can\n    rerun just those test which have failed.\n  ")]),_vm._v(" "),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"test-output"},[_c('h3',[_vm._v("Paste test failures output here:")]),_vm._v(" "),_c('div',{staticClass:"test-output__textarea-container"},[_c('textarea',{staticClass:"test-output__textarea",attrs:{"rows":"20"},domProps:{"value":_vm.testOutput},on:{"input":function($event){_vm.$emit('update:testOutput', $event.target.value)}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.testOutput),expression:"!testOutput"}],staticClass:"test-output__textarea__multiline-placeholder",domProps:{"innerHTML":_vm._s(_vm.failuresPlaceholder)}})])]),_vm._v(" "),_c('div',{staticClass:"results"},[_c('h3',[_vm._v("Results ("+_vm._s(_vm.matches.count || 0)+" test methods):")]),_vm._v(" "),_c('div',{class:{ 'without-test-output': !_vm.testOutput }},[_c('div',{staticClass:"files"},[_c('h4',[_vm._v("List of files:")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.matches.files),expression:"matches.files"}],staticClass:"files__textarea look-disabled",attrs:{"rows":"5"},domProps:{"value":(_vm.matches.files)},on:{"keypress":function($event){$event.preventDefault();},"paste":function($event){$event.preventDefault();},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.matches, "files", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"phpstorm-command"},[_c('h4',[_vm._v("PhpStorm Test Runner options:")]),_vm._v(" "),_c('input',{staticClass:"phpstorm-command__input look-disabled",domProps:{"value":_vm.matches.phpstormCommand},on:{"keypress":function($event){$event.preventDefault();},"paste":function($event){$event.preventDefault();}}})]),_vm._v(" "),_c('div',{staticClass:"cli-command"},[_c('h4',[_vm._v("CLI command:")]),_vm._v(" "),_c('input',{staticClass:"cli-command__input look-disabled",domProps:{"value":_vm.matches.cliCommand},on:{"keypress":function($event){$event.preventDefault();},"paste":function($event){$event.preventDefault();}}})])])])]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_vm._v("\n    Created by "),_c('a',{attrs:{"href":"https://www.szeremi.org/","rel":"nofollow"}},[_vm._v("Attila Szeremi")]),_vm._v(".\n    Website source code can be found on "),_c('a',{attrs:{"href":"https://github.com/amcsi/phpunit-failures","rel":"nofollow"}},[_vm._v("Github")]),_vm._v(".\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.e36737554a0fcecf1522.js